import { render, staticRenderFns } from "./BudgetRollingCompany.pug?vue&type=template&id=488d7d70&scoped=true&lang=pug&"
import script from "./BudgetRollingCompany.js?vue&type=script&lang=js&"
export * from "./BudgetRollingCompany.js?vue&type=script&lang=js&"
import style0 from "./BudgetRollingCompany.scss?vue&type=style&index=0&id=488d7d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d7d70",
  null
  
)

export default component.exports